<template>
  <div class="faq-container">
    <div class="faq-header">
      <h1>常见问题解答</h1>
      <p>通过标签筛选或关键词搜索快速找到答案</p>
      
      <!-- 搜索框 -->
      <el-input
        v-model="searchKeyword"
        placeholder="输入关键词搜索问题..."
        prefix-icon="el-icon-search"
        class="search-input"
        clearable
      ></el-input>
    </div>

    <!-- 标签分类（移动端可横向滚动） -->
    <div class="tag-scroll-container">
      <div class="tag-container">
        <el-tag 
          v-for="(tag, index) in tags" 
          :key="index"
          :type="activeTag === index ? 'primary' : ''"
          :disable-transitions="false"
          @click="activeTag = index"
          class="tag-item"
        >
          {{ tag }}
        </el-tag>
      </div>
    </div>

    <!-- 结果展示 -->
    <div class="faq-content">
      <!-- 无结果提示 -->
      <div v-if="filteredQuestions.length === 0" class="empty-result">
        <el-empty 
          description="没有找到匹配的问题"
        >
          <el-button type="text" @click="resetFilter">清空筛选条件</el-button>
        </el-empty>
      </div>
      
      <!-- 问题列表 -->
      <el-card 
        v-for="(item, idx) in filteredQuestions" 
        :key="idx" 
        class="faq-card"
        :body-style="{ padding: '2px' }"
      >
        <div slot="header" class="card-header">
          <span class="question-number">{{ idx + 1 }}.</span>
          <span class="question-text">{{ item.question }}</span>
          <!-- 显示问题所属分类标签 -->
          <el-tag size="mini" class="category-tag">{{ tags[item.category] }}</el-tag>
          <!-- 展开/折叠按钮 -->
          <el-button 
            type="text" 
            icon="el-icon-arrow-down" 
            class="toggle-btn"
            :class="{ 'rotate': expandedIndex === idx }"
            @click="toggleExpand(idx)"
          ></el-button>
        </div>
        <!-- 答案内容（控制展开/折叠） -->
        <div 
          class="card-body"
          :class="{ 'expanded': expandedIndex === idx, 'collapsed': expandedIndex !== idx }"
        >
          <div class="answer-content">
            <p v-html="item.answer"></p>
          </div>
          <!-- 给提示文本绑定点击事件 -->
          <div 
            v-if="expandedIndex !== idx" 
            class="read-more"
            @click="toggleExpand(idx)"
          >
            点击展开查看全部
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        query: '',
        pageNum: 1,
        pageSize: 2,
        token: ''
      },
      total:0 ,
      activeTag: 0, // 0表示全部标签
      searchKeyword: '',
      tags: ['全部', '课程相关', '科学游园会', '市场相关', '其他'], // 标签列表
      expandedIndex: -1, // 记录当前展开的问题索引，-1表示全部折叠
      FAQList: [],
      faqData: []
    }
  },
  created () {
    // this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getFAQList()
  },
  computed: {
    // 双重筛选：先按标签筛选，再按关键词搜索
    filteredQuestions() {
      // 1. 先按标签筛选
      let result = this.activeTag === 0 
        ? this.faqData 
        : this.faqData.filter(item => item.category === this.activeTag)
      
      // 2. 再按关键词筛选
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase()
        result = result.filter(item => 
          item.question.toLowerCase().includes(keyword) || 
          item.answer.toLowerCase().includes(keyword)
        )
      }
      
      return result
    }
  },
  methods: {
    // 获取faq列表
    async getFAQList () {
      const { data: res } = await this.$http.get('/faq/', { params: this.queryInfo })
        this.FAQList = res || []
      this.total = this.FAQList.length
      console.log(this.FAQList)
      this.faqData = this.FAQList
      if (this.total === 0) return this.$notify({ title: '失败', message: '获取常见问题失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取常见问题成功!', type: 'success' })
    },
    // 重置筛选条件
    resetFilter() {
      this.activeTag = 0
      this.searchKeyword = ''
      this.expandedIndex = -1 // 重置展开状态
    },
    // 切换问题展开/折叠状态
    toggleExpand(index) {
      // 如果点击的是当前展开的问题，则折叠它
      if (this.expandedIndex === index) {
        this.expandedIndex = -1
      } else {
        // 否则展开当前问题，关闭其他问题
        this.expandedIndex = index
      }
    }
  }
}
</script>

<style scoped lang="less">
// 基础样式
.faq-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 10px 8px; // 移动端减小左右内边距
  box-sizing: border-box;
}

.faq-header {
  text-align: center;
  margin-bottom: 15px; // 移动端减小底部间距
  
  h1 {
    color: #333;
    margin-bottom: 8px;
    font-size: 18px; // 移动端缩小标题字体
    font-weight: 600;
  }
  
  p {
    color: #666;
    margin-bottom: 10px;
    font-size: 12px; // 移动端缩小说明文字
  }
  
  .search-input {
    width: 100%;
    margin: 0 auto;
  }
}

// 标签容器（支持横向滚动）
.tag-scroll-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth; // 平滑滚动
  margin-bottom: 15px;
  padding-bottom: 8px; // 增加底部padding，避免标签被遮挡
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  .tag-container {
    display: inline-flex;
    padding: 5px 0;
    white-space: nowrap;
    
    .tag-item {
      margin: 0 4px; // 移动端减小标签间距
      cursor: pointer;
      font-size: 12px; // 移动端缩小标签字体
      padding: 4px 10px; // 移动端减小标签内边距
      transition: all 0.3s;
      
      &:hover {
        opacity: 0.9;
      }
    }
  }
}

// 内容区域
.faq-content {
  .faq-card {
    margin-bottom: 8px; // 移动端减小卡片间距
    transition: all 0.2s;
    overflow: hidden;
    border: 1px solid #e4e7ed;
    
    &:hover {
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06); // 移动端弱化阴影
    }
    
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      font-weight: 600;
      color: #333;
      padding: 6px 10px; // 移动端减小头部内边距
      cursor: pointer;
      
      .question-number {
        color: #409eff;
        margin-right: 4px;
        font-size: 13px;
      }
      
      .question-text {
        flex: 1;
        min-width: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 13px; // 移动端缩小问题字体
      }
      
      .category-tag {
        background-color: #f0f7ff;
        color: #409eff;
        border-color: #c6e2ff;
        margin: 0 6px; // 移动端减小标签间距
        font-size: 11px; // 移动端缩小标签字体
      }
      
      .toggle-btn {
        transition: transform 0.3s ease;
        padding: 8px; // 移动端增大按钮点击区域
        color: #409eff;
        font-size: 14px;
        
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    
    .card-body {
      color: #666;
      line-height: 1.5; // 移动端减小行高，节省空间
      padding: 0 10px; // 移动端减小左右内边距
      font-size: 13px; // 移动端缩小答案字体
      transition: max-height 0.5s ease, padding 0.3s ease;
      
      .answer-content {
        padding: 1px 0;
      }
      
      .read-more {
        color: #409eff;
        padding: 5px 0; // 移动端增大点击区域
        cursor: pointer;
        font-size: 12px;
        display: block;
        white-space: nowrap;
        overflow: visible;
        margin-bottom: 5px; // 移动端增加底部间距
        
        &:hover {
          color: #66b1ff;
          text-decoration: underline;
        }
      }
      
      // 折叠状态
      &.collapsed {
        // max-height: 80px; /* 稍微增大折叠状态高度 */
        max-height: none;
        padding-bottom: 3px;
        .answer-content {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 3px; // 与下方提示文本保持3px距离
        }
      }
      
      // 展开状态 - 关键修改：使用max-height + overflow-y
      &.expanded {
        max-height: 500px; /* 可根据需求调整最大高度 */
        padding: 0 10px 8px;
        overflow-y: auto; /* 内容超出时显示滚动条 */
        scrollbar-width: thin; /* 优化滚动条样式 */
        
        // 美化滚动条
        &::-webkit-scrollbar {
          width: 4px; // 移动端缩小滚动条宽度
        }
        
        &::-webkit-scrollbar-thumb {
          background-color: #ddd;
          border-radius: 2px;
        }
        
        &::-webkit-scrollbar-track {
          background-color: #f5f5f5;
        }
        
        .read-more {
          // display: none;
          // 确保提示文本显示完整
          display: block;
          padding: 3px 0; // 上下各3px距离
          white-space: nowrap; // 防止文本换行
          overflow: visible; // 确保不被截断
        }
      }
    }
  }
  
  .empty-result {
    margin: 20px 0; // 移动端减小空状态间距
    text-align: center;
    :deep(.el-empty__description) {
      font-size: 12px; // 移动端缩小空状态文字
    }
  }
}

// 响应式调整
@media (min-width: 768px) {
  .faq-container {
    padding: 15px 20px;
  }
  
  .faq-header {
    margin-bottom: 20px;
    h1 {
      font-size: 24px;
    }
    
    p {
      font-size: 14px;
    }
    
    .search-input {
      width: 60%;
      :deep(.el-input__inner) {
        height: 40px;
        font-size: 14px;
      }
    }
  }
  
  .tag-container {
    .tag-item {
      margin: 0 6px;
      font-size: 13px;
      padding: 5px 12px;
    }
  }
  
  .faq-card {
    margin-bottom: 12px;
    
    .card-header {
      padding: 8px 15px;
      
      .question-number {
        font-size: 14px;
        margin-right: 6px;
      }
      
      .question-text {
        font-size: 14px;
      }
      
      .category-tag {
        font-size: 12px;
        margin: 0 10px;
      }
      
      .toggle-btn {
        padding: 5px;
        font-size: 16px;
      }
    }
    
    .card-body {
      line-height: 1.6;
      padding: 0 15px;
      font-size: 14px;
      
      .read-more {
        font-size: 13px;
        padding: 3px 0;
      }
      
      &.expanded {
        max-height: 500px;
        padding: 0 15px 12px;
      }
    }
  }
  
  .empty-result {
    margin: 30px 0;
    :deep(.el-empty__description) {
      font-size: 14px;
    }
  }
}

// 确保卡片内边距生效（适配Less）
.faq-card {
  /deep/ .el-card__body {
    padding: 2px !important;
  }
  /deep/ .el-card__header {
    padding: 0 !important; // 清除卡片头部默认内边距
  }
}
</style>